var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.7 11.23a6.78 6.78 0 0 0 1.4-4.174C14.1 3.18 11 0 7.1 0S0 3.18 0 7.056s3.2 7.056 7.1 7.056c1.6 0 3.1-.497 4.2-1.392l3 2.982c.2.199.5.298.7.298s.5-.1.7-.298c.4-.398.4-.994 0-1.391zm-5.6.795c-2.8 0-5.1-2.186-5.1-4.97 0-2.782 2.3-5.067 5.1-5.067s5.1 2.285 5.1 5.068-2.3 4.969-5.1 4.969"
  })));
};
export { SvgSearch as ReactComponent };